import React from "react";
import { Route, Routes, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Home from "../pages/Home/Home";
import Login from "../pages/Login/Login";
import UpdatePassword from "../pages/Password/UpdatePassword";
import Profile from "../pages/Profile/Profile";
import ChangePass from "../pages/Profile/ChangePass";
import Audit from "../pages/Audit/Audit";
import Lists from "../pages/Users/Lists";
import RegisterCompany from "../pages/Register/RegisterCompany";
import EditOffice from "../pages/EditOffice/EditOffice";
import RegisterUser from "../pages/Register/RegisterUser";
import EditUserAdmin from "../pages/EditUser/EditUserAdmin";
import UserActivity from "../pages/UserActivity/UserActivity";
import ConfigPassword from "../pages/Password/ConfigPassword";
import RegisterSupplier from "../pages/Register/RegisterSupplier";
import RegisterBill from "../pages/Register/RegisterBill";
import UploadBill from "../pages/UploadBill/UploadBill";
import AssignSupplierCompany from "../pages/SupplierCompany/AssignSupplierCompany";
import EditSupplier from "../pages/EditSupplier/EditSupplier";
import EditItemBill from "../pages/EditItemBill/EditItemBill";
import EditSupplierOffice from "../pages/EditSupplierOffice/EditSupplierOffice";
import NotFound from "../pages/NotFound/NotFound";
import Insights from "../pages/Insights/Insights";

const AppRoutes = () => {
  const user = useSelector((state) => state.user);

  const privilege = user.currentUser?.privilege;
  const adminEditorOrMaster = ["admin", "master", "editor"].includes(privilege);
  const masterOrEditor = ["editor", "master"].includes(privilege);
  const adminOrMaster = ["admin", "master"].includes(privilege);
  const isMaster = privilege === "master";

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/expired-password" element={<UpdatePassword />} />
      <Route
        path="/"
        element={
          user.currentUser?.accessToken ? (
            <Outlet />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      >
        <Route index element={<Home />} />
        <Route path="/profile/:id" element={<Profile />} />
        <Route path="/pass/:id" element={<ChangePass />} />
        <Route path="/admin/audit" element={<Audit />} />
        <Route path="/insights" element={<Insights />} />

        {adminEditorOrMaster && (
          <>
            <Route path="/admin/lists" element={<Lists />} />
            <Route path="/company/register" element={<RegisterCompany />} />
            <Route path="/branchoffice/:id" element={<EditOffice />} />
          </>
        )}

        {adminOrMaster && (
          <>
            <Route path="/users/register" element={<RegisterUser />} />
            <Route path="/users/edit/:id" element={<EditUserAdmin />} />
            <Route path="/users/activity" element={<UserActivity />} />
            <Route path="/users/configPass" element={<ConfigPassword />} />
          </>
        )}

        {masterOrEditor && (
          <>
            <Route path="/supplier/register" element={<RegisterSupplier />} />
            <Route path="/itemBill/register" element={<RegisterBill />} />
            <Route path="/uploadBill" element={<UploadBill />} />
            <Route path="/supplierCompany/:idcompany" element={<AssignSupplierCompany />} />
            <Route path="/supplier/:id" element={<EditSupplier />} />
            <Route path="/itemBill/edit/:id" element={<EditItemBill />} />
          </>
        )}

        {isMaster && (
          <Route path="/supplierOffice/edit/:id" element={<EditSupplierOffice />} />
        )}
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
